module.exports = __webpack_public_path__ + "img/bbbw.1f142539.jpg";